<!--eslint-disable-->
<template xmlns="http://www.w3.org/1999/html">
  <div class="groupBuying f16">
    <div class="lin_15 f16 gray_3 fb">
      新增商品口碑视频
    </div>
    <div class="box20"></div>
    <el-button @click="cancle">< 返 回</el-button>
    <div class="box20"></div>
    <p class="ps_main_head">视频上传：仅支持mp4格式视频文件,建议视频时间在30s以内,单个视频大小不超过50m</p>
    <div>
      <el-form ref="form" :model="activityDtl" label-width="140px" label-suffix="：">
        <el-form-item label="本地上传" >
          <el-upload
            class="mar10-r"
            :action="`${env.VUE_APP_fileserver}persistentUpload`"
            :file-list="activityDtl.kbVlog.videoList"
            :on-success="uploadSuccess"
            :before-upload="uploadBefore"
            :show-file-list="false"
          >
            <div class="flex flex-column justify-center bg-f5 pointer items-center img radius5">
              <img class="block" src="./img/pc.png" />
              <div class="mar5-t f12 gray9">本地上传</div>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="手机上传" >
          <div class="flex flex-column justify-center bg-f5 pointer items-center img mar10-r radius5" @click="mobUpload">
            <img class="block" src="./img/pc.png" />
            <div class="mar5-t f12 gray9">手机上传</div>
          </div>
        </el-form-item>
<!--        <el-form-item label="" >
          <div slot="label">
            视频号视频上传:
            <div class="gray_9 f12" style="margin-top: -20px">
              仅支持小程序
            </div>
          </div>
          <el-input v-model="activityDtl.kbVlog.weChatChannelOpenId" type="text" placeholder="视频号 id，以“sph”开头的id，可在视频号助手获取" style="width: 400px"></el-input></br>
          <el-input v-model="activityDtl.kbVlog.weChatChannelVlogId" class="mar10-t" type="textarea" placeholder="视频 feedId,请以英文”，”隔开" style="width: 400px"></el-input>
        </el-form-item>-->
        <el-form-item label="预览">
          <div class="flex flex-wrap">
            <div v-for="(item, index) in activityDtl.kbVlog.videoList" :key="index" class="mar20-r">
              <div class="video-upload-info-container ">
                <div v-if="isVideo(item.videoUrl)" class="video-box">
                  <video class="video-player" :src="item.videoUrl" controls @click.stop="">
                    您的浏览器不支持视频播放
                  </video>
                  <i class="el-icon-circle-close delete-video-icon" @click.stop="del(index)"></i>
                </div>
                <div>
                  <el-input v-model="item.videoRemarks" type="text" maxlength="20" placeholder="请输入视频标题(至多20字)" style="width: 200px"></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="box20"></div>
      <div class="ps_footer t_center">
          <span slot="footer" class="dialog-footer ">
          <el-button type="primary" :disabled="disabled" @click="confirmKbVlog">确 认</el-button>
          <el-button @click="cancle">取 消</el-button>
        </span>
      </div>
      <el-dialog title="手机扫码上传" :visible.sync="mobUploadVisible" width="224px">
        <canvas width="250" height="250" ref="qrCodeCanvas" />
        <div class="text-center">支持微信和智农通</div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import requestApi from "@/utils/requestApi";
import { Loading } from "element-ui";
import { mapState } from "vuex";
import QrCode from "qrcode";
import { uuid } from "@/utils/utils";

export default {
  data() {
    return {
      loaded: false,
      env: process.env,
      activityId: "",
      activityDtl: {
        activityId: "",
        kbVlog: {
          videoList: [],
          weChatChannelVlogId: "",
          weChatChannelOpenId: "",
        },
      },
      loading: null,
      disabled: false,
      imgTransferTimer: null,
      mobUploadVisible: false,
      uuidStr: "",
    };
  },
  watch: {
    mobUploadVisible(val) {
      if (!val) {
        this.imgTransferTimer && clearInterval(this.imgTransferTimer);
        requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/del`, {
          key: this.uuidStr,
        });
      }
    },
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    const { id } = this.$route.query;
    this.activityId = id;
    this.getDtl();
  },
  methods: {
    openWindow(title, url) {
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: url,
              title: title,
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(url);
      }
    },

    getDtl() {
      let loadingInstance1 = Loading.service({ fullscreen: true });
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/selById`, {
          id: this.activityId,
          incLongText: true,
        })
        .then((res) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
            loadingInstance1.close();
            return;
          }
          if (!res.data.activityDtlList || res.data.activityDtlList.length <= 0) {
            loadingInstance1.close();
            return;
          }
          let activityRetDtl = res.data.activityDtlList[0];
          this.activityDtl.activityId = activityRetDtl.activityId;
          if (activityRetDtl.kbVlog) {
            this.activityDtl.kbVlog = activityRetDtl.kbVlog;
          }
          console.log("this.activityDtl: ", this.activityDtl);
          loadingInstance1.close();
        });
    },
    isVideo(url) {
      if (!url) {
        return false;
      }
      const ext = url.split(".").pop() || "";
      if (/mp4/.test(ext)) {
        return true;
      }
      return false;
    },
    // 视频预览
    videoPreview(url) {
      window.open(url);
    },
    // 上传图片之前
    uploadBefore(file) {
      const { size, type } = file;
      const isVerify = /(mp4)$/.test(type);
      let isLt = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是MP4格式");
      } else if (!isLt) {
        this.$message.error("存在超过50M的视频，请重新上传");
      }

      if (isVerify && isLt) {
        this.loading = this.$loading({
          lock: true,
        });
      }
      return isVerify && isLt;
    },

    uploadSuccess(res) {
      console.log("上传图片成功之后", res);
      this.loading && this.loading.close();
      const {
        data: { url },
      } = res;
      const item = {
        videoRemarks: "",
        videoUrl: url || "",
      };
      this.activityDtl.kbVlog.videoList.push(item);
    },
    // 删除图片
    del(index) {
      this.activityDtl.kbVlog.videoList.splice(index, 1);
    },
    confirmKbVlog() {
      if (!this.activityDtl.kbVlog.videoList || this.activityDtl.kbVlog.videoList.length <= 0) {
        this.$message.error("上传视频不能为空");
        return;
      }
      let loadingInstance1 = Loading.service({ fullscreen: true });

      /**
       * {
       *     "id": "74",
       *     "activityDtlList": [
       *         {
       *             "kbVlog": {
       *                 "weChatChannelOpenId": "bacd",
       *                 "weChatChannelVlogId": "csdfadfkl,afkofdkoa,sdafaosjdf",
       *                 "videoList": [
       *                     {
       *                         "videoUrl": "https://nfs.t.nxin.com/d5f9cc7081954442868acb3bb5ff55db.mp4",
       *                         "videoRemarks": "哈哈哈"
       *                     }
       *                 ]
       *             }
       *         }
       *     ]
       * }
       */
      let activityDtlList = [];
      let dtlObj = {};
      let kbVlog = {};
      kbVlog.weChatChannelOpenId = this.activityDtl.kbVlog.weChatChannelOpenId;
      kbVlog.weChatChannelVlogId = this.activityDtl.kbVlog.weChatChannelVlogId;
      let videoList = [];
      this.activityDtl.kbVlog.videoList.forEach((item) => {
        let video = {};
        video.videoUrl = item.videoUrl;
        video.videoRemarks = item.videoRemarks;
        videoList.push(video);
      });
      kbVlog.videoList = videoList;
      dtlObj.kbVlog = kbVlog;
      activityDtlList.push(dtlObj);
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}sctrading/activity/commonactivity/mj/modify`, {
          id: this.activityId,
          activityDtlList: activityDtlList,
        })
        .then((res) => {
          loadingInstance1.close();
          if (res.code != 0) {
            this.$message.error(res.msg);
            return;
          }
          this.$message.success("保存成功");
          setTimeout(() => {
            this.cancle();
          }, 2000);
        });
    },
    cancle() {
      window.location.href = `${process.env.VUE_APP_APP}v/mj/kbVlog/list?appid=1&isShowTitle=1`;
    },
    mobUpload() {
      this.mobUploadVisible = true;
      this.uuidStr = uuid();
      setTimeout(() => {
        QrCode.toCanvas(this.$refs.qrCodeCanvas, `${process.env.VUE_APP_static}imgTransfer/index3.html?t=${new Date().getTime()}&uuid=${this.uuidStr}`);
      }, 100);

      this.imgTransferTimer && clearInterval(this.imgTransferTimer);
      this.imgTransferTimer = setInterval(async () => {
        const { data } = await requestApi.post(`${process.env.VUE_APP_APITAAS}scbasic/system/redis/sel`, {
          key: this.uuidStr,
        });
        data.valList.forEach((url) => {
          if (!this.activityDtl.kbVlog.videoList.some((item) => item.videoUrl == url)) {
            const item = {
              videoRemarks: "",
              videoUrl: url || "",
            };
            this.activityDtl.kbVlog.videoList.push(item);
          }
        });
      }, 2000);
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0;
}

@import "index";
</style>
<style>
.el-button--primary,
.el-button--primary:hover,
.el-button--primary:focus {
  background: #1286ff;
  border-color: #1286ff;
  color: #ffffff;
}
</style>
